export default __webpack_public_path__ + "static/media/Voldemort's Wand - Img - Wip 1_01.9236a80f.jpg";